const VerticalTabsStyle = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: "100%",
    position: "relative",
  },
  headerPapper: {
    width: "50px",
    height: "50px",
  },
  tabs: {
    backgroundColor: "#1C4445",
    height: "100%",
    transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    position: "absolute",
    overflow: "hidden",
    zIndex: 1,
    "& > div": {
      height: "100% !important",
      overflow: "hidden !important",
    },
  },
  tabContainerSelected: {
    background: "#667e7f",
  },
  centered: {
    alignItems: "center",
  },
  tabContainer: {
    display: "flex",
    width: 320,
    height: 124,
    alignItems: "center",
    color: "white",
    cursor: "pointer",
  },
  tabFirstContainer: {
    marginTop: 38,
  },
  tabContainerSurveyWrapper: {
    display: "flex",
    flex: 1,
    alignItems: "flex-end",
    paddingBottom: 12,
  },
  flexContainerVertical: {
    height: "100%",
  },
  calenderIcon: {
    width: 32,
    height: 36,
    minHeight: 36,
    maxHeight: 36,
    minWidth: 32,
    maxWidth: 32
  },
  folderIcon: {
    width: 36,
    height: 28,
    minHeight: 28,
    maxHeight: 28,
    minWidth: 36,
    maxWidth: 36
  },
  iconWrapper: {
    width: '92px',
    display: 'flex',
    justifyContent: 'center'
  },

  searchIcon: {
    width: "32px !important",
    height: "34px !important",
    minHeight: "34px !important",
    maxHeight: "34px !important",
    minWidth: "32px !important",
    maxWidth: "32px !important",
  },
  dashboardIcon: {
    width: 32,
    height: 32,
    minHeight: 32,
    maxHeight: 32,
    minWidth: 32,
    maxWidth: 32,
    marginLeft: 31,
    marginRight: 31,
  },
  commentIconCollapse: {
    width: 28,
    height: 28,
    minHeight: 28,
    maxHeight: 28,
    minWidth: 28,
    maxWidth: 28,
    marginLeft: 31,
    marginRight: 35,
  },
  commentIconExpand: {
    width: 24,
    height: 24,
    minHeight: 24,
    maxHeight: 24,
    minWidth: 24,
    maxWidth: 24,
    marginLeft: 16,
    marginRight: 16,
  },
  commentIconTransition: {
    transition: "all 1s ease-out",
  },
  tabPanelStyles: {
    display: "flex",
    flex: 1,
    marginLeft: 92,
  },
  tabPannelClassName: {
    display: "flex",
    flex: 1,
  },
  sideBarTextPrimary: {
    fontFamily: "Proxima Nova",
    fontSize: 22,
  },
  sideBarTextSecondary: {
    fontSize: 16,
    fontFamily: "Proxima Nova",
    lineHeight: "19px",
  },
  tabIndicatorStyle: {
    background: "transparent",
  },
  disabledCursor: {
    cursor: "default !important",
  },
});

export default VerticalTabsStyle;
